import {
    ADD_POST,
    POST_LOADING,
    GET_POSTS,
    GET_POST,
    GET_POSTS_SCROLL,
} from "../actions/types";

const initialState = {
    posts: [],
    post: {},
    has_more: true,
    total: 0,
    loading: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case ADD_POST:
            return {
                ...state,
                posts: [action.payload, ...state.posts],
            };
        case POST_LOADING:
            return {
                ...state,
                loading: !state.loading,
            };
        case GET_POSTS:
            return {
                ...state,
                posts: action.payload,
            };
        case GET_POSTS_SCROLL:
            return {
                ...state,
                posts: [...state.posts, ...action.payload.results],
                has_more: action.payload.has_more,
                total: action.payload.total,
            };

        case GET_POST:
            // let index = action.payload._id;
            return {
                ...state,
                post: action.payload,
            };

        default:
            return state;
    }
}
